import React from 'react';
import { Flame, TrendingUp, Calendar } from 'lucide-react';
import { COMMIT_DATA } from '../../data/config';
import WidgetContainer from '../WidgetContainer';

const CommitStreak = ({ delay = 0 }) => {
  const generateHeatmapData = () => {
    const data = [];
    for (let week = 0; week < 12; week++) {
      const weekData = [];
      for (let day = 0; day < 7; day++) {
        weekData.push(Math.floor(Math.random() * 5));
      }
      data.push(weekData);
    }
    return data;
  };

  const heatmapData = generateHeatmapData();

  return (
    <WidgetContainer size="2x2" delay={delay}>
      <div className="widget-header">
        <h3>Commit Streak</h3>
        <Flame className="widget-icon animate-glow" />
      </div>

      {/* Streak Stats */}
      <div className="grid grid-cols-3 gap-3 mb-6">
        <div className="bg-coffee-700/20 hover:bg-coffee-700/30 transition-colors rounded-lg p-3 text-center border border-coffee-700/30">
          <div className="text-2xl font-bold text-caramel-300">{COMMIT_DATA.currentStreak}</div>
          <div className="text-xs text-coffee-300 uppercase tracking-wider mt-1">Current</div>
        </div>
        <div className="bg-coffee-700/20 hover:bg-coffee-700/30 transition-colors rounded-lg p-3 text-center border border-coffee-700/30">
          <div className="text-2xl font-bold text-cream-100">{COMMIT_DATA.longestStreak}</div>
          <div className="text-xs text-coffee-300 uppercase tracking-wider mt-1">Longest</div>
        </div>
        <div className="bg-coffee-700/20 hover:bg-coffee-700/30 transition-colors rounded-lg p-3 text-center border border-coffee-700/30">
          <div className="text-2xl font-bold text-cream-100">{COMMIT_DATA.totalCommits}</div>
          <div className="text-xs text-coffee-300 uppercase tracking-wider mt-1">Total</div>
        </div>
      </div>

      {/* Language Breakdown */}
      <div className="mb-4">
        <h4 className="text-xs font-semibold text-coffee-300 uppercase tracking-wider mb-3 flex items-center gap-2">
          <TrendingUp className="w-3.5 h-3.5 text-caramel-400" />
          Language Breakdown
        </h4>
        <div className="space-y-2">
          {COMMIT_DATA.languageBreakdown.map((lang) => (
            <div key={lang.name}>
              <div className="flex justify-between text-xs mb-1">
                <span className="text-coffee-200">{lang.name}</span>
                <span className="text-cream-100 font-medium font-mono">{lang.percentage}%</span>
              </div>
              <div className="h-2 bg-coffee-700/30 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500"
                  style={{
                    width: `${lang.percentage}%`,
                    backgroundColor: lang.color,
                    boxShadow: `0 0 10px ${lang.color}66`,
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contribution Heatmap */}
      <div>
        <h4 className="text-xs font-semibold text-coffee-300 uppercase tracking-wider mb-3 flex items-center gap-2">
          <Calendar className="w-3.5 h-3.5 text-caramel-400" />
          Last 12 Weeks
        </h4>
        <div className="flex gap-1">
          {heatmapData.map((week, weekIndex) => (
            <div key={weekIndex} className="flex flex-col gap-1">
              {week.map((level, dayIndex) => (
                <div
                  key={dayIndex}
                  className={`heatmap-cell heatmap-level-${level}`}
                  title={`${level} contributions`}
                ></div>
              ))}
            </div>
          ))}
        </div>
        <div className="flex items-center justify-end gap-2 text-xs text-coffee-300 mt-3">
          <span>Less</span>
          <div className="flex gap-1">
            {[0, 1, 2, 3, 4].map((l) => (
              <span key={l} className={`heatmap-cell heatmap-level-${l}`}></span>
            ))}
          </div>
          <span>More</span>
        </div>
      </div>
    </WidgetContainer>
  );
};

export default CommitStreak;
